import { render, staticRenderFns } from "./MediaPackageChangeActivationType.vue?vue&type=template&id=77efefa3&"
import script from "./MediaPackageChangeActivationType.vue?vue&type=script&lang=js&"
export * from "./MediaPackageChangeActivationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports